import { render, staticRenderFns } from "./MultiSelectJournal.vue?vue&type=template&id=46a7ddd5"
import script from "./MultiSelectJournal.vue?vue&type=script&lang=ts"
export * from "./MultiSelectJournal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports